<template>
  <div>
    <div class="lg:flex lg:justify-between items-center mb-8">
      <div class="md:flex md:items-end md:gap-3.5">
        <DateRangePicker
          :startDate="startDate"
          :endDate="endDate"
          :startDateOption="dateOption"
          :endDateOption="dateOption"
          prefixIcon="dataIcon"
          @change="onPickerChange"
        />
        <el-button
          class="blue_button fgp_blue_button update_button h-[36px] !min-w-30 rtl:mr-0"
          @click="getHistoryData"
        >
          {{ $t('promotion.fundsGrowthPromotion.button.update') }}
        </el-button>
      </div>
      <div class="mt-8 lg:mt-0">
        {{
          $t('promotion.fundsGrowthPromotion.history.resultDate', {
            startDate: displayStartDate,
            endDate: displayEndDate
          })
        }}
      </div>
    </div>
    <div>
      <div class="table_box">
        <el-table class="w-full" :data="displayData">
          <el-table-column
            prop="settlementDate"
            :label="$t('promotion.fundsGrowthPromotion.history.tableHeader.date')"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="tradingAccount"
            :label="$t('promotion.fundsGrowthPromotion.history.tableHeader.account')"
            min-width="120"
          ></el-table-column>
          <el-table-column :label="$t('promotion.fundsGrowthPromotion.history.tableHeader.interest')" min-width="120">
            <template slot-scope="scope">{{ scope.row.interest ? '$' + scope.row.interest : '--' }}</template>
          </el-table-column>
          <el-table-column :label="$t('promotion.fundsGrowthPromotion.history.tableHeader.invalid')" min-width="200">
            <template slot-scope="scope">
              <span
                >{{
                  scope.row.failReason.length > 0
                    ? $t(`promotion.fundsGrowthPromotion.history.invalidReason.${scope.row.failReason[0]}`)
                    : '--'
                }}
              </span>
              <el-popover v-if="scope.row.failReason.length > 1" placement="top-start" trigger="hover">
                <span class="popover_content">{{ getConcatenatedFailReasons(scope.row.failReason) }}</span>
                <span slot="reference" class="cursor-pointer">...</span>
              </el-popover>
            </template>
          </el-table-column>
          <template slot="empty">{{ $t('promotion.fundsGrowthPromotion.history.noHistory') }}</template>
        </el-table>
      </div>

      <pagination
        :table-data="tableData"
        :display-data.sync="displayData"
        :customizedPageSize="10"
        :searchTriggered="searchTriggered"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import DateRangePicker from '@/components/DateRangePicker';
import moment from 'moment';
import { apiGetFgpHistory } from '@/resource';

export default {
  name: 'FgpHistory',
  components: {
    DateRangePicker,
    Pagination
  },
  props: {
    optIn: { type: Boolean },
    campaignId: { type: Number }
  },
  data() {
    const defaultRangeInMonths = 1;
    const exportEndDate = moment().toDate();
    const exportStartDate = moment(exportEndDate).subtract(defaultRangeInMonths, 'months').toDate();

    return {
      startDate: exportStartDate,
      endDate: exportEndDate,
      dateFormat: 'YYYY-MM-DD',
      displayResultDateFormat: 'DD/MM/YYYY',
      dateOption: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
          return moment(time).isAfter(moment());
        }
      },
      tableData: [],
      displayData: [],
      displayStartDate: '',
      displayEndDate: '',
      searchTriggered: false
    };
  },
  watch: {
    optIn() {
      this.getHistoryData();
    }
  },
  methods: {
    onPickerChange(val) {
      this.startDate = val[0];
      this.endDate = val[1];
    },
    getHistoryData() {
      this.searchTriggered = true;
      this.displayStartDate = moment(this.startDate).format(this.displayResultDateFormat);
      this.displayEndDate = moment(this.endDate).format(this.displayResultDateFormat);
      if (this.optIn) {
        const req = {
          campaignId: this.campaignId,
          startDate: moment(this.startDate).format(this.dateFormat),
          endDate: moment(this.endDate).format(this.dateFormat)
        };

        apiGetFgpHistory(req).then(resp => {
          this.searchTriggered = false;
          if (resp.data.code === 0 && resp.data.data) {
            this.tableData = [];
            resp.data.data.forEach(acc => {
              acc.history.forEach(x => {
                this.tableData.push({
                  settlementDate: moment(x.settlementDate).format('DD-MM-YYYY'),
                  tradingAccount: acc.mt4Account,
                  interest: x.interest?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                  failReason: x.failReasons
                });
              });
            });

            this.tableData = this.tableData.sort(
              (a, b) => moment(b.settlementDate, 'DD-MM-YYYY') - moment(a.settlementDate, 'DD-MM-YYYY')
            );
          }
        });
      } else {
        this.tableData = [];
        this.searchTriggered = false;
      }
    },
    getConcatenatedFailReasons(data) {
      const reasons = data.slice(1);
      return reasons.map(x => this.$t(`promotion.fundsGrowthPromotion.history.invalidReason.${x}`)).join('; ');
    }
  },
  mounted() {
    this.getHistoryData();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/fundsGrowthPromotion/history.scss';
</style>
